import React, { ReactElement } from 'react';
import Store from 'mockStores/components/stores/Store';

function NoFlows(): ReactElement {
  return (
    <Store
      title="Honey Checkout Mock Store (No Flows)"
      description="No checkout flows should trigger on this page!"
    />
  );
}

export default NoFlows;
